import React from "react";

export const CrossFunctionalScoreTable: React.FC = () => (
  <div>
    {" "}
    <table
      style={{
        minWidth: 280,
        background: "#444",
        color: "#fff",
        borderCollapse: "collapse",
        fontSize: 13,
        boxShadow: "0 2px 10px rgba(0,0,0,0.10)",
      }}
    >
      <thead>
        <tr>
          <th
            style={{
              background: "#555",
              color: "#fff",
              fontWeight: 700,
              border: "1px solid #88a",
              padding: "6px 14px",
              textAlign: "center",
              minWidth: 80,
            }}
            rowSpan={2}
          >
            Score
          </th>
          <th
            style={{
              background: "#555",
              color: "#fff",
              fontWeight: 700,
              border: "1px solid #88a",
              padding: "6px 14px",
              textAlign: "center",
            }}
            colSpan={2}
          >
            Amount rewarded (₹)
          </th>
        </tr>
        <tr>
          <th
            style={{
              background: "#555",
              color: "#fff",
              fontWeight: 700,
              border: "1px solid #88a",
              padding: "6px 12px",
              textAlign: "center",
              minWidth: 80,
            }}
          >
            Team
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              fontWeight: 600,
              textAlign: "center",
            }}
          >
            60-64
          </td>

          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              textAlign: "center",
            }}
          >
            10000
          </td>
        </tr>
        <tr>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              fontWeight: 600,
              textAlign: "center",
            }}
          >
            65-69
          </td>

          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              textAlign: "center",
            }}
          >
            20000
          </td>
        </tr>
        <tr>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              fontWeight: 600,
              textAlign: "center",
            }}
          >
            70-74
          </td>

          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              textAlign: "center",
            }}
          >
            30000
          </td>
        </tr>
        <tr>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              fontWeight: 600,
              textAlign: "center",
            }}
          >
            75-79
          </td>

          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              textAlign: "center",
            }}
          >
            40000
          </td>
        </tr>
        <tr>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              fontWeight: 600,
              textAlign: "center",
            }}
          >
            80-84
          </td>

          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              textAlign: "center",
            }}
          >
            50000
          </td>
        </tr>
        <tr>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              fontWeight: 600,
              textAlign: "center",
            }}
          >
            85-89
          </td>

          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              textAlign: "center",
            }}
          >
            60000
          </td>
        </tr>
        <tr>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              fontWeight: 600,
              textAlign: "center",
            }}
          >
            90-94
          </td>

          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              textAlign: "center",
            }}
          >
            70000
          </td>
        </tr>
        <tr>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              fontWeight: 600,
              textAlign: "center",
            }}
          >
            95 & above
          </td>

          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              textAlign: "center",
            }}
          >
            80000
          </td>
        </tr>
      </tbody>
    </table>{" "}
  </div>
);
export const CrossFunctionalScoreTableTrailBlazer: React.FC = () => (
  <div>
    {" "}
    <table
      style={{
        minWidth: 280,
        background: "#444",
        color: "#fff",
        borderCollapse: "collapse",
        fontSize: 13,
        boxShadow: "0 2px 10px rgba(0,0,0,0.10)",
      }}
    >
      <thead>
        <tr>
          <th
            style={{
              background: "#555",
              color: "#fff",
              fontWeight: 700,
              border: "1px solid #88a",
              padding: "6px 14px",
              textAlign: "center",
              minWidth: 80,
            }}
            rowSpan={2}
          >
            Score
          </th>
          <th
            style={{
              background: "#555",
              color: "#fff",
              fontWeight: 700,
              border: "1px solid #88a",
              padding: "6px 14px",
              textAlign: "center",
            }}
            colSpan={2}
          >
            Amount rewarded (₹)
          </th>
        </tr>
        <tr>
          <th
            style={{
              background: "#555",
              color: "#fff",
              fontWeight: 700,
              border: "1px solid #88a",
              padding: "6px 12px",
              textAlign: "center",
              minWidth: 80,
            }}
          >
            Team
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              fontWeight: 600,
              textAlign: "center",
            }}
          >
            10-14
          </td>

          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              textAlign: "center",
            }}
          >
            8000
          </td>
        </tr>
        <tr>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              fontWeight: 600,
              textAlign: "center",
            }}
          >
            15-19
          </td>

          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              textAlign: "center",
            }}
          >
            10000
          </td>
        </tr>
        <tr>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              fontWeight: 600,
              textAlign: "center",
            }}
          >
            20-24
          </td>

          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              textAlign: "center",
            }}
          >
            15000
          </td>
        </tr>
        <tr>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              fontWeight: 600,
              textAlign: "center",
            }}
          >
            25
          </td>

          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              textAlign: "center",
            }}
          >
            20000
          </td>
        </tr>
      </tbody>
    </table>{" "}
  </div>
);
export const REExcellenceScoreTable: React.FC = () => (
  <>
    {" "}
    <table
      style={{
        minWidth: 280,
        background: "#444",
        color: "#fff",
        borderCollapse: "collapse",
        fontSize: 13,
        boxShadow: "0 2px 10px rgba(0,0,0,0.12)",
      }}
    >
      <thead>
        <tr>
          <th
            style={{
              background: "#555",
              color: "#fff",
              fontWeight: 700,
              border: "1px solid #88a",
              padding: "6px 14px",
              textAlign: "center",
              minWidth: 80,
            }}
            rowSpan={2}
          >
            Score
          </th>
          <th
            style={{
              background: "#555",
              color: "#fff",
              fontWeight: 700,
              border: "1px solid #88a",
              padding: "6px 14px",
              textAlign: "center",
            }}
            colSpan={2}
          >
            Amount rewarded(₹)
          </th>
        </tr>
        <tr>
          <th
            style={{
              background: "#555",
              color: "#fff",
              fontWeight: 700,
              border: "1px solid #88a",
              padding: "6px 12px",
              textAlign: "center",
              minWidth: 80,
            }}
          >
            Individual
          </th>
          <th
            style={{
              background: "#555",
              color: "#fff",
              fontWeight: 700,
              border: "1px solid #88a",
              padding: "6px 12px",
              textAlign: "center",
              minWidth: 80,
            }}
          >
            Team
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              fontWeight: 600,
              textAlign: "center",
            }}
          >
            60-64
          </td>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              textAlign: "center",
            }}
          >
            5000
          </td>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              textAlign: "center",
            }}
          >
            10000
          </td>
        </tr>
        <tr>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              fontWeight: 600,
              textAlign: "center",
            }}
          >
            65-69
          </td>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              textAlign: "center",
            }}
          >
            10000
          </td>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              textAlign: "center",
            }}
          >
            20000
          </td>
        </tr>
        <tr>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              fontWeight: 600,
              textAlign: "center",
            }}
          >
            70-74
          </td>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              textAlign: "center",
            }}
          >
            15000
          </td>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              textAlign: "center",
            }}
          >
            30000
          </td>
        </tr>
        <tr>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              fontWeight: 600,
              textAlign: "center",
            }}
          >
            75-79
          </td>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              textAlign: "center",
            }}
          >
            20000
          </td>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              textAlign: "center",
            }}
          >
            40000
          </td>
        </tr>
        <tr>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              fontWeight: 600,
              textAlign: "center",
            }}
          >
            80-84
          </td>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              textAlign: "center",
            }}
          >
            25000
          </td>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              textAlign: "center",
            }}
          >
            50000
          </td>
        </tr>
        <tr>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              fontWeight: 600,
              textAlign: "center",
            }}
          >
            85-89
          </td>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              textAlign: "center",
            }}
          >
            30000
          </td>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              textAlign: "center",
            }}
          >
            60000
          </td>
        </tr>
        <tr>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              fontWeight: 600,
              textAlign: "center",
            }}
          >
            90-94
          </td>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              textAlign: "center",
            }}
          >
            35000
          </td>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              textAlign: "center",
            }}
          >
            70000
          </td>
        </tr>
        <tr>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              fontWeight: 600,
              textAlign: "center",
            }}
          >
            95 & above
          </td>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              textAlign: "center",
            }}
          >
            40000
          </td>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              textAlign: "center",
            }}
          >
            80000
          </td>
        </tr>
      </tbody>
    </table>
  </>
);
export const TrailBlazerScoreTable: React.FC = () => (
  <>
    {" "}
    <table
      style={{
        minWidth: 250,
        background: "#444",
        color: "#fff",
        borderCollapse: "collapse",
        fontSize: 13,
        boxShadow: "0 2px 10px rgba(0,0,0,0.12)",
      }}
    >
      <thead>
        <tr>
          <th
            style={{
              background: "#555",
              color: "#fff",
              fontWeight: 700,
              border: "1px solid #88a",
              padding: "6px 14px",
              textAlign: "center",
              minWidth: 60,
            }}
            rowSpan={2}
          >
            Score
          </th>
          <th
            style={{
              background: "#555",
              color: "#fff",
              fontWeight: 700,
              border: "1px solid #88a",
              padding: "6px 14px",
              textAlign: "center",
            }}
            colSpan={2}
          >
            Amount rewarded (₹)
          </th>
        </tr>
        <tr>
          <th
            style={{
              background: "#555",
              color: "#fff",
              fontWeight: 700,
              border: "1px solid #88a",
              padding: "6px 12px",
              textAlign: "center",
              minWidth: 60,
            }}
          >
            Individual
          </th>
          <th
            style={{
              background: "#555",
              color: "#fff",
              fontWeight: 700,
              border: "1px solid #88a",
              padding: "6px 12px",
              textAlign: "center",
              minWidth: 60,
            }}
          >
            Team
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              fontWeight: 600,
              textAlign: "center",
            }}
          >
            5-9
          </td>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              textAlign: "center",
            }}
          >
            2500
          </td>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              textAlign: "center",
            }}
          >
            8000
          </td>
        </tr>
        <tr>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              fontWeight: 600,
              textAlign: "center",
            }}
          >
            10-14
          </td>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              textAlign: "center",
            }}
          >
            5000
          </td>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              textAlign: "center",
            }}
          >
            8000
          </td>
        </tr>
        <tr>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              fontWeight: 600,
              textAlign: "center",
            }}
          >
            15-19
          </td>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              textAlign: "center",
            }}
          >
            7500
          </td>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              textAlign: "center",
            }}
          >
            10000
          </td>
        </tr>
        <tr>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              fontWeight: 600,
              textAlign: "center",
            }}
          >
            20-24
          </td>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              textAlign: "center",
            }}
          >
            10000
          </td>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              textAlign: "center",
            }}
          >
            15000
          </td>
        </tr>
        <tr>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              fontWeight: 600,
              textAlign: "center",
            }}
          >
            25
          </td>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              textAlign: "center",
            }}
          >
            15000
          </td>
          <td
            style={{
              border: "1px solid #88a",
              padding: "5px 12px",
              textAlign: "center",
            }}
          >
            20000
          </td>
        </tr>
      </tbody>
    </table>
  </>
);
